import React from 'react';
import './Background.css';
import { EXPERIENCE, WRITING, EDUCATION, SKILLS } from '../content';

export default function Background() {
  return (
    <section id="background" className="background section-pad">
      <div className="wrap bg-head">
        <p className="eyebrow eyebrow--accent">Background</p>
        <h2 className="section-title">Where this came from</h2>
      </div>

      <div className="wrap bg-grid">
        <div className="bg-col">
          <h3 className="bg-col-title">Experience</h3>
          <ol className="bg-list">
            {EXPERIENCE.map((e) => (
              <li className="bg-item" key={e.org + e.role}>
                <p className="bg-period">{e.period}</p>
                <h4 className="bg-role">{e.role}</h4>
                <p className="bg-org">{e.org}</p>
                <p className="bg-note">{e.note}</p>
              </li>
            ))}
          </ol>

          <h3 className="bg-col-title bg-col-title--spaced">Writing</h3>
          <ol className="bg-list">
            {WRITING.map((w) => (
              <li className="bg-item" key={w.doi}>
                <p className="bg-period">
                  {w.period} · {w.venue}
                </p>
                <h4 className="bg-role">
                  <a className="bg-link" href={w.href} target="_blank" rel="noreferrer">
                    {w.title}
                  </a>
                </h4>
                <p className="bg-org">doi:{w.doi}</p>
                <p className="bg-note">{w.note}</p>
              </li>
            ))}
          </ol>
        </div>

        <div className="bg-col">
          <h3 className="bg-col-title">Education</h3>
          <ol className="bg-list">
            {EDUCATION.map((e) => (
              <li className="bg-item" key={e.award}>
                <p className="bg-period">{e.period}</p>
                <h4 className="bg-role">{e.award}</h4>
                <p className="bg-org">{e.school}</p>
              </li>
            ))}
          </ol>

          <h3 className="bg-col-title bg-col-title--spaced">Skills</h3>
          <dl className="bg-skills">
            {SKILLS.map((s) => (
              <div className="bg-skill-row" key={s.group}>
                <dt>{s.group}</dt>
                <dd>{s.items}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
